import React from 'react';

export default function ChatwootEmbed() {
  return (
    <div className="h-[calc(100vh-80px)] w-full">
      <iframe
        src="https://chatwoot.minhainbase.com.br"
        className="w-full h-full border-0 rounded-xl shadow"
        title="Chatwoot"
        allow="camera; microphone; clipboard-write"
      />
    </div>
  );
}
